import { Injectable, NgZone } from '@angular/core';
import { Observable, tap } from "rxjs";
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private clientId = '571005421079-280eoghn2oo4et3nafv4ibtn672g2g4n.apps.googleusercontent.com';
  private apiUrl = environment.nodeApiUrl;

  constructor(private http: HttpClient, private router: Router, private ngZone: NgZone) {}

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/user/login`, { email, password }).pipe(
      tap((userData) => {
        if (userData) {
          localStorage.setItem('user', JSON.stringify(userData));
        }
      })
    );
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem('user') || 'null');
  }

  logoutUser() {
    localStorage.removeItem('user');
    return this.http.get(`${this.apiUrl}/api/user/logout`);
  }

  initGoogleLogin() {
    google.accounts.id.initialize({
      client_id: this.clientId,
      callback: this.handleCredentialResponse.bind(this),
    });

    google.accounts.id.renderButton(
      document.getElementById('googleSignInButton'),
      { theme: 'outline', size: 'large' }
    );
  }

  handleCredentialResponse(response: any) {
    const token = response.credential;
    console.log('Google Token:', token);

    const user: any = jwtDecode(token);
    console.log('User Details:', user);

    this.ngZone.run(() => {
      this.router.navigate(['/student/chat']);
    });
  }
}
